import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=0629c32c&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0629c32c')) {
      api.createRecord('0629c32c', component.options)
    } else {
      api.reload('0629c32c', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=0629c32c&", function () {
      api.rerender('0629c32c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Z7J6MtWY38WQ/JS/pricehelp.vue"
export default component.exports